import { PARAMS } from './pages';

export const ACTION_PLAN_FIELDS = {
  CREATOR: 'creator',
  CREATED_ON: 'created_on',
  COURSES: 'courses',
  DESCRIPTION: 'description',
  DUE_DATE: 'due_date',
  STATUS: 'is_finished',
  NOTIFY: 'notify',
  USER: 'user',
  TITLE: 'title',
  TYPE: 'type',
  TAGS: 'tags',
  TASKS: 'tasks',
  PROGRESS: 'progress',
  MODIFIED_ON: 'modified_on',
  IS_PROPOSED: 'is_proposed',
  IS_PENDING_PROPOSAL: 'is_pending_proposal',
};

export const ACTION_PLAN_COMMENTS_DEFAULT_PARAMS = {
  [PARAMS.PAGE]: 1,
  [PARAMS.PAGE_SIZE]: 10,
};

export const DUE_DATE_TIME_FORMAT = 'MMM d, yyyy';
